import React from 'react';
import { useParams } from 'react-router-dom';
import { StringParam, useQueryParams } from 'use-query-params';
import styled from 'styled-components';

import { CmsEditorFrame } from 'src/components/cms-editor-frame';

import { useDefaultEnterpriseCName } from './use-default-enterprise-cname';

export default function WebStudioEditor(): JSX.Element {
  const { enterpriseId, modelId } = useParams<{ enterpriseId: string; modelId: string }>();
  const [{ variantKey }] = useQueryParams({ variantKey: StringParam });
  // The CMS editor always needs a store cName to preview against; default it from
  // the enterprise. Hold off mounting the frame until it resolves so the iframe
  // isn't loaded once without a cName and then reloaded once it arrives.
  const { cName, loading } = useDefaultEnterpriseCName(enterpriseId);

  return (
    <EditorPage>
      {!loading && (
        <CmsEditorFrame
          enterpriseId={enterpriseId}
          modelId={modelId}
          variantKey={variantKey ?? undefined}
          cName={cName}
        />
      )}
    </EditorPage>
  );
}

const EditorPage = styled.div`
  height: 100vh;
  width: 100vw;
  overflow: hidden;
`;
